import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

interface ContainerProps {
  isActive?: boolean;
}

export const Container = styled('div')<ContainerProps>`
  align-items: ${(props) =>
    props.expanded?.toString() === 'true' ? 'left' : 'center'};
  background-color: ${(props) =>
    props.isActive ? `${colours.neutral[200]}` : 'none'};
  border-radius: 60px;
  box-sizing: border-box;
  color: black;
  cursor: pointer;
  display: flex;
  gap: 10px;
  height: 60px;
  justify-content: ${(props) =>
    props.expanded?.toString() === 'true' ? 'left' : 'center'};
  max-height: 60px;
  padding: 20px;
  position: relative;
  width: ${(props) =>
    props.expanded?.toString() === 'true' ? '100%' : '60px'};

  svg {
    height: 20px;
    width: 20px;
    stroke-width: 2;
  }

  &:hover {
    background-color: ${(props) =>
      props.isActive ? `${colours.neutral[200]}` : `${colours.neutral[300]}`};
  }

  @media (max-width: ${breakpoints.laptop}) {
    padding: 25px;
  }
`;

export const InactiveContainer = styled(Container)`
  opacity: 0.6;
  cursor: default;
  pointer-events: none;
`;

export const Label = styled('div')`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const UserContent = styled('div')`
  display: flex;
  flex-direction: column;
`;
